module.exports = __webpack_public_path__ + "img/2-12-6.07c823ef.png";